<template>
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      minHeight: '100vh',
      height: 'auto',
      paddingBottom: '10px'
    }"
  >
    <header-o :model="headerData"></header-o>
    <div
      class=""
      style="padding-left: 15px;padding-right: 15px; margin-top: -170px"
    >
      <div
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
          borderRadius: '10px'
        }"
        class="past-history-section common-section height-cus"
      >
        <div class="past-history-title text-center">
          <div
            :style="{
              backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
              borderTopLeftRadius: '10px',
              borderTopRightRadius: '10px'
            }"
            class="offer-card bg-light padding-5 pos-rel"
            style="display: flex;
                    justify-content: flex-start;
                    align-items:center; border-bottom: 1px solid #bebebe;"
          >
            <img
              class="medium-icon margin-right-5 margin-bottom-10"
              style="width: 50px;
                height: 50px;
                margin: 4px;"
              src="@/assets/Leaderboard Assest//Score.svg"
            />
            <div
              class="margin-bottom-10 padding-vertical-10 font-extra-bold text-large past-history-title"
              style="display: flex;flex-direction: column;    align-items: baseline;"
            >
              <span>
                <span style="font-weight: lighter; color: #736C6C;"
                  >Your Score</span
                >
              </span>
              <span style="display: flex;"
                ><span
                  style="font-size: 18px; color: #323232; font-weight: 500 !important;"
                  >{{ historydata.total_score }}
                  {{ historydata.reward_type }}</span
                ></span
              >
            </div>
          </div>

          <div
            class="history-table border-top"
            style="border-top: 0px solid #dee2e6 !important"
          >
            <div class="table-responsive " style="scrollbar-width: none;">
              <table class="table table-borderless">
                <tbody>
                  <tr
                    v-for="item in historydata.history"
                    style="	padding: 2px;border-bottom: 1px solid #bebebe"
                  >
                    <td
                      style="padding-top: 10px; font-size:14px; display:flex; flex-direction:column"
                    >
                      <p
                        style="margin-bottom: 12px !important; color: #544e4e;"
                      >
                        {{ item.event_title }}
                      </p>
                      <p>{{ item.ref_num }}</p>
                    </td>
                    <td
                      class="name"
                      style="padding-right: 10px;; font-size:14px; display:flex; flex-direction:column;    max-width: 130px; align-items: end;"
                    >
                      <p
                        style="color: #407B07;margin-left: 60px;margin-bottom: 12px !important;"
                      >
                        +{{ item.score }}
                      </p>
                      <p style="color: #544e4e;">
                        {{
                          moment(item.created_at)
                            .startOf()
                            .fromNow()
                        }}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            style="margin-top: 20px;"
            v-if="historydata.history && historydata.history.length == 0"
          >
            {{ historydata.message }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import OverlapHeader from "@/components/overlapped-header";
import moment from "moment";
export default {
  mixins: [globals],
  components: {
    "header-o": OverlapHeader
  },
  data() {
    return {
      headerData: {
        onlyHeader: true
      },
      historydata: {},
      is_shimmer: true,
      moment: null
    };
  },
  computed: {
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    showShimmer: function() {
      return this.is_shimmer;
    }
  },
  beforeMount() {
    var self = this;
    if (window.addEventListener) {
      window.addEventListener("message", self.handleSDKMessage, false);
    } else {
      window.attachEvent("onmessage", self.handleSDKMessage);
    }
    this.loadDataFromCookie();
    // this.getFlyyAppinfo();
  },
  methods: {
    getleaderboardHistory(id) {
      var self = this;
      if (self.hasPartnerToken) {
        axios.all([this.getleaderHistory(id)]).then(
          axios.spread(resp => {
            if (resp.status == 200) {
              var data = resp.data;
              this.historydata = resp.data;
            }
          })
        );
      }
    }
  },
  created() {
    this.moment = moment;
    var store_state = this.$store.state;
    store_state.showHeader = false;
    store_state.showWallet = false;
    store_state.showHistory = false;
    store_state.user.headerBalance.show = false;
    store_state.headTitle = "Score History";
    document.documentElement.style.setProperty(
      "--bg-color",
      this.$store.state.bg_theme
    );
    document.documentElement.style.setProperty(
      "--bg-light-color",
      this.$store.state.bg_theme + "59"
    );
    if (!this.isEmpty(this.$route.params)) {
      this.getleaderboardHistory(this.$route.params.id);
    }
  }
};
</script>
<style scoped>
@import "../../assets/quiz-styles/quiz-styles.css";
@import "../../assets/quiz-styles/bootstrap.css";
@import "../../assets/fonts/quiz-fonts/fonts.css";
.currency-type {
  position: absolute;
  top: 10px;
  right: 10px;
}
.currency-type.dummy {
  right: 30px;
}
th,
tr {
  display: flex;
  justify-content: space-between;
  padding: 10px 21px;
}
.past-history-title span {
  font-family: "Montserrat-bold", sans-serif;
  font-size: 14px;
  line-height: 19px;
  color: #373535;
}

/* Very small phones (iPhone SE, older Android) */
@media (max-width: 360px) {
  .height-cus {
    min-height: 100vh;
  }
}

/* Normal mobiles (iPhone 12/13/14/15, Samsung A/M series) */
@media (min-width: 361px) and (max-width: 480px) {
  .height-cus {
    min-height: 100vh;
  }
}
</style>
